import { cn as classname } from '@bem-react/classname';

export const cnNotifications = classname('Notifications');
